var _a, _b, _c;
import { parse } from 'platform';
import canUseDOM from './canUseDOM';
export var devicePlatform = parse(canUseDOM() ? navigator.userAgent : undefined);
export var isAppleTouchDevice = ((_a = devicePlatform.os) === null || _a === void 0 ? void 0 : _a.family) === 'iOS' ||
    ((_b = devicePlatform.os) === null || _b === void 0 ? void 0 : _b.family) === 'iPad OS' ||
    (((_c = devicePlatform.os) === null || _c === void 0 ? void 0 : _c.family) === 'OS X' &&
        !!navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2);
//# sourceMappingURL=browser.js.map